import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c656b8ac&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=c656b8ac&prod&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=c656b8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c656b8ac",
  null
  
)

export default component.exports